import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Animated, Easing, Image } from 'react-native';
//import { useNavigation } from '@react-navigation/native';
import { useNavigate } from 'react-router-dom';

import rightArrow from './assets/icons/arrowright.png';
import diamond from './assets/icons/diamond.png';
import close from './assets/icons/close.png';

const MenuPanel = ({ isVisible, onClose }) => {
  const slideAnim = new Animated.Value(isVisible ? 0 : -250);
  //const navigation = useNavigation();
const navigate = useNavigate();

  React.useEffect(() => {
    Animated.timing(slideAnim, {
      toValue: isVisible ? 0 : -250,
      duration: 300,
      easing: Easing.ease,
      useNativeDriver: true,
    }).start();
  }, [isVisible]);

  const handleSubscription = (direction) => {
    navigate(`/${direction.toLowerCase()}`); // Naviga alla pagina
    onClose(); // Chiude il menu
  };

  return (
    <Animated.View style={[styles.menuContainer, { transform: [{ translateX: slideAnim }] }]}>
      <TouchableOpacity onPress={onClose} style={styles.closeButton}>
        <Image source={close} style={styles.icon} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.menuItem} onPress={() => handleSubscription('')}>
        <Text style={styles.menuText}>Home</Text>
        <Image source={rightArrow} style={styles.icon} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.menuItem} onPress={() => handleSubscription('PageProducts')}>
        <Text style={styles.menuText}>Prodotti</Text>
        <Image source={rightArrow} style={styles.icon} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.menuItem} onPress={() => handleSubscription('LimitedEditionPage')}>
        <Text style={styles.menuText}>Limited Edition</Text>
        <Image source={diamond} style={styles.iconbigger} />
        <Image source={rightArrow} style={styles.icon} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.menuItem} onPress={() => handleSubscription('ContactPage')}>
        <Text style={styles.menuText}>Contatti</Text>
        <Image source={rightArrow} style={styles.icon} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.menuItem} onPress={() => handleSubscription('FaqPage')}>
        <Text style={styles.menuText}>Domande frequenti</Text>
        <Image source={rightArrow} style={styles.icon} />
      </TouchableOpacity>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  menuContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: 250,
    height: 'auto',
    backgroundColor: '#ffffff',
    paddingTop: 5,
    zIndex: 1000,
    borderWidth: 1,
    borderColor: '#F0F0F0',
  },
  closeButton: {
    padding: 10,
    alignSelf: 'flex-end',
  },
  closeText: {
    fontSize: 20,
  },
  menuItem: {
    height: 40,
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 10,
    justifyContent: 'space-between',
  },
  menuText: {
    height: 10,
    fontSize: 14,
    alignSelf: 'center',
  },
  iconbigger: {
    height: 20,
    width: 20,
    marginLeft: -80,
    marginTop: 3,
    alignSelf: 'flex-start',
  },
  icon: {
    height: 15,
    width: 15,
    alignSelf: 'center',
  },
});

export default MenuPanel;
